module.exports = __webpack_public_path__ + "static/media/new-listing.0be6e21b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Listing/new-listing.svg
// module id = 472
// module chunks = 0